import { Tag } from "@carbon/react";
import { OverflowMenuVertical } from "@carbon/react/icons";

import { device_type, fraud_and_risk_level } from "../../enums";
import { formatAsCurrency } from "../../utils";

import mobileDevice from "../../assets/icons/mobile-device.svg";
import pcMonitor from "../../assets/icons/pc-monitor.svg";

export const fraudsAndRisksDisplayFormatter = (item) => {
  const statusIndicator =
    item.fraud_and_risk_level === fraud_and_risk_level.high
      ? { statusText: "high", statusType: "red" }
      : item.fraud_and_risk_level === fraud_and_risk_level.low
      ? { statusText: "low", statusType: "green" }
      : { statusText: "medium", statusType: "gray" };

  return {
    ...item,
    amount: (
      <strong>
        {item.currency_symbol} {formatAsCurrency(item.amount)}
      </strong>
    ),
    fraud_and_risk_level: (
      <Tag className="transaction-status" type={statusIndicator.statusType}>
        <span>{statusIndicator.statusText}</span>
        <div
          style={{ backgroundColor: statusIndicator.statusType }}
          className="status-indicator"
        />
      </Tag>
    ),
    ip_address: (
      <div>
        <img
          src={
            item.customer.device_type === device_type.mobile
              ? mobileDevice
              : pcMonitor
          }
          alt="device type icon"
          className="device-type-icon"
        />{" "}
        {item.customer.ip_address}
      </div>
    ),
    description: <strong>{item.description}</strong>,
    customer: item.customer.email,
    gateway: (
      <img
        src={`${process.env.PUBLIC_URL}/${item.gateway_logo_url}`}
        alt="gateway logo"
      />
    ),
    date: <span className="date--oneline">{item.date}</span>,
    // more: <OverflowMenuVertical />,
  };
};
